import React from 'react';
import { option } from "./option";
import GetCaseStudies from "./GetCaseStudies";

interface Props {
  currentSite: Page.Site;
  solutionOptions: Array<{ id: string; title: string }>;
  label: Record<string, string>;
  role: Record<string, string>;
}

interface State {
  filters: {
    solution: string;
    industry: string;
    platform: string;
    region: string;
    category: string;
  };
  solutions: Array<{ id: string; title: string }>;
  industries: Array<{ value: string; label: string }>;
  platforms: Array<{ value: string; label: string }>;
  regions: Array<{ value: string; label: string }>;
  limit: number;
  page: number;
}

class CaseStudies extends React.Component<Props, State> {
  // dafault value
  constructor(props: Props) {
    super(props);
    this.state = {
      filters: {
        solution: "*",
        industry: "*",
        platform: "*",
        region: "*",
        category: "*",
      },
      solutions: props.solutionOptions,
      industries: option.industries,
      platforms: option.platforms,
      regions: option.regions,
      limit: 9,
      page: 1,
    };
  }

  getOptionLabel = (option: { id: string; title: string } | { value: string; label: string }) => {
    if ("title" in option) {
      return option.title; // { id: string; title: string }
    }
    if ("label" in option) {
      return option.label; // { value: string; label: string }
    }
    return "";
  };

  handleFilterChange = (key: keyof State["filters"], value: string) => {
    this.setState((prevState) => ({
      filters: { ...prevState.filters, [key]: value },
      page: 1,
    }));
  };

  handlePageChange = ({value}:{value: number}) => {
    this.setState({
      page: value
    });
  };

  handleReload = () => {
    window.location.reload();
  }

  render() {
    const { filters, solutions, industries, platforms, regions, limit, page } = this.state;
    const { label, role, currentSite } = this.props;

    return (
      <>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {[
            {
              label: label.csolutions,
              options: solutions,
              valueKey: "id",
              labelKey: "title",
              stateKey: "solution",
            },
            {
              label: label.cindustry,
              options: industries,
              valueKey: "value",
              labelKey: "label",
              stateKey: "industry",
            },
            {
              label: label.cplatform,
              options: platforms,
              valueKey: "value",
              labelKey: "label",
              stateKey: "platform",
            },
            {
              label: label.cregion,
              options: regions,
              valueKey: "value",
              labelKey: "label",
              stateKey: "region",
            },
          ].map(({ label, options, valueKey, labelKey, stateKey }) => (
            <div className="w-full" key={stateKey}>
              <p className="text-sm mb-2 font-semibold">{label}</p>
              <select
                className="block w-full mt-1 rounded-md border-gray-100 focus:border-gray-300"
                name={filters[stateKey as keyof State["filters"]]}
                defaultValue={"*"}
                onChange={(e) =>
                  this.handleFilterChange(stateKey as keyof State["filters"], e.target.value)
                }
              >
                <option value="*">{this.props.label.allLable}</option>
                {options.map((option) => (
                  <option key={"id" in option ? option.id : option.value} value={"id" in option ? option.id : option.value}>
                    {this.getOptionLabel(option)}
                  </option>
                ))}
              </select>
            </div>
          ))}
        </div>

        <div className="space-x-4 text-center">
          {["partner", "customer"].map((category) => (
            <label key={category}>
              <input
                className="mr-3 w-5 h-5 border-gray-300 text-green text-xl focus:border-green-300 focus:ring focus:ring-transparent"
                type="radio"
                name="category"
                value={category}
                checked={filters.category === category}
                onChange={(e) => this.handleFilterChange("category", e.target.value)}
              />
              {role[category]}
            </label>
          ))}
        </div>

        <div>
          <GetCaseStudies
            label={label}
            currentSite={currentSite}
            {...filters}
            limit={limit}
            page={page}
            getCaseStudiesByPage={this.handlePageChange}
          />
        </div>
      </>
    );
  }
}

export default CaseStudies;